import { detectPort } from './detect-port.js';

export default detectPort;

export * from './detect-port.js';
// keep alias detectPort to detect
export const detect = detectPort;

export * from './wait-port.js';
